export default "src/content/themes/association-wordpress-theme/img/cf4d60e194972bf5944fc1a0c7dc1ac9.jpg";